<template id='content'>
	<div class="bg">
		<div class="top">
			<div class="top_c">
				<div>找回密码</div>
			</div>
		</div>
		<div class="bottom">
			<div class="b_t">找回密码</div>
			<div class="b_c">
				<div class="clearfix">
					<div class="b_c_1" v-for="(stepitem,idx) in steplist" :key="idx">
						<div class="b_c_1_bg" :class="{background:idx==step,background1:idx<step}"></div>
						<div class="b_c_1_c" :class="{background:idx==step,background1:idx<step}">{{stepitem.id+1}}</div>
						<div class="b_c_1_t" :class="{color:idx==0,color1:idx<step}">{{stepitem.text}}</div>
					</div>
				</div>
			</div>
			<div>
				<ul class="ul3">
					<li class="clearfix">
						<span class="fl">新登录密码：</span>
						<input class="fl psw1" type="password" maxlength="20" v-model="psw1" >
					</li>
					<li class="clearfix">
						<span class="fl">确认新密码：</span>
						<input class="fl psw2" type="password" maxlength="20" v-model="psw2" >
					</li>
					<li class="clearfix">
						<input class="btn fl" @click="spet3" type="button" value="提交">
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import Qs from 'qs'
	import { ip,sha1 } from '../../assets/js/public.js'
  import bus from '../../assets/js/eventBus'
  import Cookies from 'js-cookie'

	export default {
		data () {
			return {
				steplist:[{'id':0,'text':'填写账户名'},{'id':1,'text':'验证身份'},{'id':2,'text':'设置新密码'},{'id':3,'text':'完成'}],
				psw1:'',
				psw2:'',
				step:null
			}
		},
		mounted:function () {
			var t_=this
			t_.step=t_.$route.query.step-1
		},
		methods:{
			spet3:function(){
				var t_=this
				if(!t_.psw1||!t_.psw2)return this.$message({
					message:'请填写密码',
					center:true,
					type:'warning'
				})
				if(t_.psw1.length<6||t_.psw2.length<6)return this.$message({
					message:'密码不得小于6位',
					center:true,
					type:'warning'
				})
				if(sha1(t_.psw1)!=sha1(t_.psw2))return this.$message({
					message:'密码输入不一致，请重新填写',
					center:true,
					type:'warning'
				})
				if(!localStorage.member0bj)return this.$message({
					message:'超时了，请从第一步开始哦~！',
					center:true,
					type:'warning'
				})
				var data0bj = Qs.stringify({
					id:JSON.parse(localStorage.member0bj).id,
					password:sha1(t_.psw1)
				})
				axios.post(
					`${ip}formWorkInterface/updatePwd`,data0bj
				).then( res => {
					if(res.data.code==300){
						var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
						return window.open(href.href,'_blank')
					}
					if(res.data.code!=0)return this.$message({
						message:res.data.message,
						center:true,
						type:'warning'
					})
					localStorage.setItem('member0bj','')
					localStorage.setItem('name','')
					localStorage.setItem('tamp','')
          Cookies.set('name', '')
          Cookies.set('tamp', '')
					this.$router.push({path: '/setPassword4',query:{ step:4}});
				} )
			}
		}
	}
</script>

<style>
	html,body{
    height: 100%;
  }
	.clearfix {
		overflow: auto;
		_height: 1%;
	}
	.fl{
		float: left;
	}
	.bg{
		background: #f5f5f5;
		height: 100%;
	}
	.top{
		background: #fff;
		height: 116px;
		border-bottom: 3px solid #ff2c4c;
	}
	.top_c{
		width: 990px;
		height: 116px;
		margin: 0 auto;
	}
	.top_c div{
		font-size: 24px;
		color:#2d2d2d;
		margin-left: 20px;
		line-height: 96px;
	}
	.bottom{
		width: 990px;
		height: 530px;
		background: #fff;
		margin: 0 auto;
	}
	.b_t{
		height: 44px;
		padding: 24px 0 0 21px;
		color:#666;
		font-weight: 900;
	}
	.b_c{
		width: 634px;
		margin: 0 auto;
		overflow: hidden;
	}
	.b_c_1{
		width: 25%;
		height: 40px;
		position: relative;
		float: left;
		overflow: hidden;
	}
	.b_c_1_bg{
		width: 100%;
		height: 5px;
		background: #cdcdcd;
		position: absolute;
		top: 10px;
	}
	.b_c_1_c{
		width: 23px;
		height: 23px;
		border-radius: 50%;
		background: #cdcdcd;
		color: #fff;
		text-align: center;
		line-height: 23px;
		margin: 0 auto;
		position: relative;
	}
	.b_c_1_t{
		color:#666;
		text-align: center;
		margin-top: 1px;
	}
	.background{
		background: #7abd54;
	}
	.color{
		color:#7abd54;
	}
	.color1{
		color:#cbedb7;
	}
	.background1{
		background:#cbedb7;
	}
	.ul3{
		width: 245px;
		margin: 44px auto;
	}
	.ul3 li{
		margin-bottom: 20px;
	}
	.ul3 span{
		font-size:14px;
		color: #999;
		line-height: 36px;
	}
	.ul3 .psw1,.ul3 .psw2{
		width: 150px;
		height: 34px;
		padding-left: 5px;
		border: 1px solid #ccc;
	}
	.ul3 .btn{
		width: 62px;
		height: 32px;
		border: 0;
		border-radius: 7px;
		color:#fff;
		background: #de2c3a;
		margin-left: 85px;
	}
</style>


// WEBPACK FOOTER //
// src/components/setPassword/setPWD3.vue